(function () {
    function loadHubSpotFormsScript() {
        return new Promise(function (resolve, reject) {

            if (typeof hbspt !== 'undefined' && hbspt.forms) {
                resolve();
                return;
            }

            var script = document.createElement('script');
            script.charset = 'utf-8';
            script.type = 'text/javascript';
            script.src = '//js.hsforms.net/forms/embed/v2.js';
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    function initNewsletterForm() {
        var formTarget = document.querySelector('#hubspot-newsletter-form');
        if (!formTarget) {
            return;
        }

        loadHubSpotFormsScript()
            .then(function () {
                createNewsletterHSForm();
            })
            .catch(function (error) {
                console.error('Failed to load HubSpot script:', error);
            });
    }

    function createNewsletterHSForm() {
        if (typeof hbspt === 'undefined' || !hbspt.forms) {
            setTimeout(createNewsletterHSForm, 120);
            return;
        }

        hbspt.forms.create({
            portalId: "492239",
            formId: "d957ee60-6d3f-4e0a-a7a7-04fe79dc761f",
            region: "na1",
            target: "#hubspot-newsletter-form"
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initNewsletterForm);
    } else {
        initNewsletterForm();
    }

})();
